import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITransitionSlice } from './types';
import { FadeMode } from 'shared-types/SharedTypes';

const NS = 'transitionSlice';

const initialState: ITransitionSlice = {
  editBookingFadeMode: FadeMode.noFade,
};

const transitionSlice = createSlice({
  name: 'transition',
  initialState,
  reducers: {
    setEditBookingFadeMode: (state: ITransitionSlice, action: PayloadAction<FadeMode>) => {
      state.editBookingFadeMode = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = transitionSlice;
// Extract and export each action creator by name
export { actions as transitionActions };
// Export the reducer, either as a default or named export
export default reducer;
